<template>
	<v-card>
		<v-card-title>
			<span class="text-h6">
				{{ sample.bean?.name || '未选豆' }}
			</span>
		</v-card-title>
		<v-card-subtitle>
			{{ sample.cupping?.location || '—' }}
		</v-card-subtitle>
		<v-card-text class="d-flex flex-row align-center justify-space-between">
			<div class="d-flex flex-column">
				<span class="">{{ sample.beanqty }}g {{ sample.method }}</span>
				<span class="xtext-h6">水温：{{ sample.watertemp }}度</span>
				<span class="xtext-h6">萃取率：{{ sample.extractionyield }}</span>
				<span class="xtext-h6">研磨：{{ grindLabel }}</span>
			</div>
			<v-chip size="x-large" color="success" class="xtext-h6">{{ score }}分</v-chip>
		</v-card-text>
		<slot name="actions" v-bind="{ sample }"></slot>
	</v-card>
</template>

<script>
export default {
	props: {
		sample: Object
	},
	data() {
		return {}
	},
	computed: {
		score() {
			const scores = this.sample?.scores || []
			if (!scores.length) return '—'
			const sum = scores.reduce((acc, curr) => acc + Number(curr.total || 0), 0)
			return (sum / scores.length).toFixed(1)
		},
		grindLabel() {
			const size = this.sample?.grindsize || ''
			const name = this.sample?.grinder_name || ''
			return name ? `${name} ${size}`.trim() : size
		}
	},
	methods: {}
}
</script>

<style scoped></style>
